'use strict';

/**
 * 取、签、见、撤信息弹窗
 */
angular.module('resourceInfoModule', []).controller('infoModalCtrl', function($scope, $modalInstance, $timeout, $location, $anchorScroll, resourceCenterService, params, modalDialog, trsHttpService) {

    // 锚点切换开始
    $scope.goto = function(id) {
        $scope.status.selected = id;
        $location.hash(id);
        $anchorScroll();
    };


    initStatus();
    initData();

    /**
     * [initStatus description]
     *
     * @return  {[type]}  [return description]
     */
    function initStatus() {
        $scope.showRepeatInfo = params.isShowRepeat;
        $scope.infos = {
            QU: [],
            QIAN: [],
            CHE: [],
            JIAN: [],
            TUI: []
        };
        $scope.status = {
            QU: angular.isDefined(params.operFlags) ? (params.operFlags.substr(0, 1) == '1') : false,
            QIAN: angular.isDefined(params.operFlags) ? (params.operFlags.substr(1, 1) == '1') : false,
            JIAN: angular.isDefined(params.operFlags) ? (params.operFlags.substr(2, 1) == '1') : false,
            CHE: angular.isDefined(params.operFlags) ? (params.operFlags.substr(3, 1) == '1') : false,
            TUI: angular.isDefined(params.operFlags) ? (params.operFlags.substr(5, 1) == '1') : false,
            isUGC: angular.isDefined(params.isUGC) ? params.isUGC : false,
            isTenant: angular.isDefined(params.isTenant) ? params.isTenant : false,
            isPropaganda: angular.isDefined(params.isPropaganda) ? params.isPropaganda : false,
            isCrossTenant: angular.isDefined(params.isCrossTenant) ? params.isCrossTenant : false,
            IsCurTenant: true
        };
        $scope.status.isShowTab = true; // 是否显示tab
        $scope.status.selected = params.showClick;
    }

    /**
     * [initData description]
     *
     * @return  {[type]}  [return description]
     */
    function initData() {
        var item = {
            MetaDataId: params.docId
        };
        if ($scope.status.isUGC === true) {
            var dataParams = {
                serviceid: 'mlf_ugc',
                methodname: 'queryFlagList',
                UgcId: params.docId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), dataParams, 'post').then(function(data) {
                $scope.infos = data;
                angular.forEach($scope.infos.QU, function(value, key) {
                    if (angular.isDefined(value.OPERUSER)) {
                        var temp = value.OPERUSER.split('-');
                        value.OPERUSER = temp.length > 1 ? temp[0] + '-' + temp.pop() : temp[0];
                    }
                });
            }, function() {
                modalDialog.alertType('', '获取稿件标签失败!', 'error', false);
            });
        } else if ($scope.status.isTenant === true) {
            item = {
                dataId: params.docId,
            };
            resourceCenterService.getTenantOperTags(item).then(function(data) {
                var arr = data.OPERS;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].OPERNAME == '取稿') {
                        $scope.infos.QU.push(arr[i]);
                    } else if (arr[i].OPERNAME == '签发' || arr[i].OPERNAME == '定时签发') {
                        $scope.infos.QIAN.push(arr[i]);
                    } else if (arr[i].OPERNAME == '撤稿') {
                        $scope.infos.CHE.push(arr[i]);
                    } else if (arr[i].OPERNAME == '退稿') {
                        $scope.infos.TUI.push(arr[i]);
                    } else {
                        $scope.infos.JIAN.push(arr[i]);
                    }
                }
                // $scope.infos.QU = data['QU'];
                // $scope.infos.QIAN = data['QIAN'];
                // $scope.infos.JIAN = data['JIAN']
                // $scope.infos.CHE = data['CHE']
                // $scope.infos.CHONG = data['CHONG'];
            }, function() {
                modalDialog.alertType('', '获取稿件标签失败!', 'error', false);
            });
        } else if ($scope.status.isPropaganda) {
            item = {
                dataId: params.docId,
            };
            resourceCenterService.getPropagandaOperTags(item).then(function(data) {
                var arr = data.OPERS;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].OPERNAME == '取稿') {
                        $scope.infos.QU.push(arr[i]);
                    } else if (arr[i].OPERNAME == '签发' || arr[i].OPERNAME == '定时签发') {
                        $scope.infos.QIAN.push(arr[i]);
                    } else if (arr[i].OPERNAME == '撤稿') {
                        $scope.infos.CHE.push(arr[i]);
                    } else if (arr[i].OPERNAME == '退稿') {
                        $scope.infos.TUI.push(arr[i]);
                    } else {
                        $scope.infos.JIAN.push(arr[i]);
                    }
                }
                // $scope.infos.QU = data['QU'];
                // $scope.infos.QIAN = data['QIAN'];
                // $scope.infos.JIAN = data['JIAN']
                // $scope.infos.CHE = data['CHE']
                // $scope.infos.CHONG = data['CHONG'];
            }, function() {
                modalDialog.alertType('', '获取稿件标签失败!', 'error', false);
            });
        } else {
            item.IsCurTenant = $scope.status.IsCurTenant;
            resourceCenterService.getOperations(item).then(function(data) {
                var arr = data.OPERS;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].OPERNAME == '取稿') {
                        $scope.infos.QU.push(arr[i]);
                    } else if (arr[i].OPERNAME == '签发' || arr[i].OPERNAME == '定时签发') {
                        $scope.infos.QIAN.push(arr[i]);
                    } else if (arr[i].OPERNAME == '撤稿') {
                        $scope.infos.CHE.push(arr[i]);
                    } else if (arr[i].OPERNAME == '退稿') {
                        $scope.infos.TUI.push(arr[i]);
                    } else {
                        $scope.infos.JIAN.push(arr[i]);
                    }
                }
            }, function() {
                modalDialog.alertType('', '获取稿件标签失败!', 'error', false);
            });
        }

    }

    /**
     * [getOperInfo description] 获取操作信息
     * @return {[type]} [description]
     */
    function getOperInfo() {
        var params = {
            MetaDataId: params.id,
            methodname: 'queryOperations',
            serviceid: 'mlf_releaseSource',
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            $scope.infos.QU = data.OPERS;
        });
    }
    $scope.callback = function() {
        $scope.status.IsCurTenant = !$scope.status.IsCurTenant;
        $scope.infos = {
            QU: [],
            QIAN: [],
            CHE: [],
            JIAN: [],
            TUI: []
        };
        initData();
    };
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.toggleShowRepeatInfo = function(value) {
        $scope.showRepeatInfo = value;
    };
}).controller('bigDataInfoModalCtrl', function($scope, $modalInstance, $timeout, $location, $anchorScroll, resourceCenterService, options, modalDialog) {
    $scope.showRepeatInfo = options.isShowRepeat;
    var params = {
        'guid': options.guid,
    };
    $scope.status = {
        QU: angular.isDefined(options.operFlags) ? (options.operFlags.substr(0, 1) == '1') : false,
        QIAN: angular.isDefined(options.operFlags) ? (options.operFlags.substr(1, 1) == '1') : false,
        JIAN: angular.isDefined(options.operFlags) ? (options.operFlags.substr(2, 1) == '1') : false,
        CHE: angular.isDefined(options.operFlags) ? (options.operFlags.substr(3, 1) == '1') : false,
        TUI: angular.isDefined(options.operFlags) ? (options.operFlags.substr(5, 1) == '1') : false,
    };
    $scope.status.isShowTab = true; // 是否显示tab
    $scope.status.selected = options.showClick;

    /* 锚点切换开始*/
    $scope.goto = function(id) {
        $scope.status.selected = id;
        $location.hash(id);
        $anchorScroll();
    };
    resourceCenterService.getBigDataOperTags(params).then(function(data) {
        $scope.infos = data;
        angular.forEach($scope.infos.QU, function(value, key) {
            if (angular.isDefined(value.OPERUSER)) {
                var temp = value.OPERUSER.split('-');
                value.OPERUSER = temp.length > 1 ? temp[0] + '-' + temp.pop() : temp[0];
            }
        });
    }, function() {
        modalDialog.alertType('', '获取稿件标签失败!', 'error', false);
    });
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.toggleShowRepeatInfo = function(value) {
        $scope.showRepeatInfo = value;
    };
})

/* .
controller('xhsgInfoModalCtrl', function($scope, $modalInstance, $timeout, $location, $anchorScroll, resourceCenterService, params, modalDialog) {
    $scope.showRepeatInfo = params.isShowRepeat;
    //锚点切换开始
    $scope.goto = function(id) {
        $location.hash(id);
        $anchorScroll();
    };
    var params = {
        'MetaDataId': params.docId
    }
    resourceCenterService.getXhsgOperTags(params).then(function(data) {
        $scope.infos = data;
        angular.forEach($scope.infos.QU, function(value, key) {
            if (angular.isDefined(value.OPERUSER)) {
                var temp = value.OPERUSER.split('-');
                value.OPERUSER = temp.length > 1 ? temp[0] + '-' + temp.pop() : temp[0];
            }
        });
    }, function() {
        modalDialog.alertType("", "获取稿件标签失败!", "error", false);
    });
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.toggleShowRepeatInfo = function(value) {
        $scope.showRepeatInfo = value;
    }
})*/
;
